import type { RouteRecordRaw } from "vue-router";
import { SharedModule } from "@/modules/shared/enums";

export default <RouteRecordRaw[]>[
  {
    path: "",
    meta: {
      module: SharedModule.Authorisation,
    },
    children: [
      {
        path: "",
        name: "auth.login",
        component: () =>
          import("@/modules/shared/authorisation/views/LoginView.vue"),
      },
      {
        path: "/auth/password-forgotten",
        name: "auth.forgot",
        component: () =>
          import("@/modules/shared/authorisation/views/PasswordForgottenView.vue"),
      },
      {
        path: "/auth/password/reset",
        name: "auth.reset",
        component: () =>
          import("@/modules/shared/authorisation/views/PasswordResetView.vue"),
      },
      {
        path: "/auth/2fa",
        name: "auth.2fa",
        component: () =>
          import("@/modules/shared/authorisation/views/OTPView.vue"),
      },
      {
        path: "/auth/callback",
        name: "auth.callback",
        component: () =>
          import("@/modules/shared/authorisation/views/CallBackView.vue"),
      },
    ],
  },
];
